
	import { defineComponent, PropType } from 'vue';

	import FiscalYearReport from '@/ChildrenComponents/Reports/FiscalYearReport.vue';

	import { IFiscalYearReportByProgram, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

	export default defineComponent({
		name: 'fiscal-year-report-by-program',
		components: { FiscalYearReport },
		props: {
			title: { type: String, required: true },
			filename: { type: String, required: true },
			isSearching: { type: Boolean, required: true },
			reportData: { type: Object as PropType<IFiscalYearReportByProgram[]>, required: true },
			totalColumnTitle: { type: String, required: false, default: "Total" },
		},
		emits: ["search"],
		data () {
			return {
				reportHeaders: [
                    { title: "Program", key: "programName", sortable: true, align: "start" },
				] as IDataTableHeader[],
			}
		},
		methods: {
			search(searchDto: IFiscalYearReportSearch) {
				this.$emit("search", searchDto);
			}
		},
	});
